import { Box } from '@mui/material'
import { FieldTemplateProps } from '@rjsf/utils'

export const FieldTemplate = (props: FieldTemplateProps) => {
  if (props.schema.type === 'object') {
    let padding = '16px'

    if (Object.values(props.schema.properties || {})[0]?.['type'] === 'array') {
      padding = '0px'
    }

    return (
      <Box
        sx={{
          justifyContent: 'flex-start',
          flexWrap: 'wrap',
          flexDirection: 'column',
          padding: padding,
          '& .field-template': {
            padding: 0,
          },
        }}
        className="field-template"
      >
        {props.children}
        {props.errors}
        {props.help}
      </Box>
    )
  } else {
    return (
      <Box
        sx={{
          width: '100%',
        }}
      >
        {props.children}
      </Box>
    )
  }
}
